import React from 'react';
import './IdentityBand.css';
import { Plane, Shield, Network } from 'lucide-react';

const IDENTITY_ICONS = [
  { Icon: Plane,   label: 'Fly',   testId: 'icon-fly' },
  { Icon: Shield,  label: 'Serve', testId: 'icon-serve' },
  { Icon: Network, label: 'Build', testId: 'icon-build' },
];

const IdentityBand = () => {
  return (
    <section className="identity-band" id="identity" data-testid="identity-section">
      <div className="identity-content">
        <h2 className="identity-name" data-testid="identity-name">
          Vishaal Hariprasad — BX → SF
        </h2>

        <div
          className="coordinates"
          data-testid="coordinates"
          aria-label="Geographic coordinates: South Bronx and San Francisco"
        >
          <span className="coordinate">40.8367° N, 73.9214° W</span>
          <span className="coordinate">37.7898° N, 122.4253° W</span>
        </div>

        <div className="identity-icons" data-testid="identity-icons" aria-label="Roles">
          {IDENTITY_ICONS.map(({ Icon, label, testId }) => (
            <div
              key={testId}
              className="icon-item"
              role="img"
              aria-label={label}
              data-testid={testId}
            >
              <Icon size={20} strokeWidth={1.5} aria-hidden="true" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IdentityBand;
